import { service } from "@ember/service";
import { Ability } from "ember-can";
import type SemeiaSessionService from "parog-web/services/session";

export default class HealthCentreAbility extends Ability {
  @service declare session: SemeiaSessionService;

  get canInvoice(): boolean {
    return Boolean(
      this.session.medic?.healthCentres.some(
        hc => hc.productName == "nephrowise"
      )
    );
  }
}
